import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54')
];

export const server_loads = [];

export const dictionary = {
		"/": [10],
		"/(protected)/admin/(content)/aspen-services": [11],
		"/(protected)/admin/(content)/emergency-broadcast": [12],
		"/admin/feedbacks/[id]": [17],
		"/(protected)/admin/(content)/ml-scanner": [13],
		"/admin/sites/unassigned": [18],
		"/ai-workflow": [19],
		"/(protected)/alerts-concept": [14],
		"/alerts": [20,[],[2]],
		"/alerts/[id]": [21,[],[2,3]],
		"/analytics/energy-forecast": [22],
		"/analytics/performance": [23,[4]],
		"/analytics/performance/map": [24,[4]],
		"/analytics/performance/overview": [25,[4]],
		"/analytics/performance/sites": [26,[4]],
		"/approved-alerts": [27,[],[5]],
		"/approved-alerts/[id]": [28,[],[5,6]],
		"/dashboard": [29],
		"/dashboard/admin": [30],
		"/(protected)/dashboard/admin/data-explorer": [15],
		"/(protected)/dashboard/admin/technician-map": [16],
		"/feedback": [31],
		"/field-tech": [32,[7]],
		"/field-tech/alerts": [33,[7]],
		"/field-tech/profile": [34,[7]],
		"/field-tech/schedule": [35,[7]],
		"/field-tech/session/[id]": [36,[7]],
		"/field-tech/tracking": [37,[7]],
		"/field-tech/work-orders": [38,[7]],
		"/field-tech/work-orders/[id]": [39,[7]],
		"/login": [40],
		"/logs": [41],
		"/logs/security": [42],
		"/maintenance": [43],
		"/ml-predictions": [44],
		"/my-feedback": [45],
		"/my-feedback/[id]": [46],
		"/password-reset": [47],
		"/profile": [48],
		"/reports/daily": [49],
		"/reset-password": [~50],
		"/sites": [51],
		"/sites/[assetId]": [52],
		"/work-orders": [53,[],[8]],
		"/work-orders/[id]": [54,[],[8,9]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';